<template>
  <div class="__card__order-return mt-3">
    <h1 class="__card__order-return_title">Hoàn tiền cho khách</h1>
    
    <div v-if="!refundPolicy" class="row w-100 d-flex justify-content-center my-2">
      <div class="col-10">
        <b-alert class="custom-alert m-0" show variant="warning text-dark">
          Giá trị cần hoàn trả bằng 0 do cửa hàng đã bật cấu hình <b>“Không hoàn tiền khi đổi trả hàng”</b>.<br />
          Để cài đặt lại, vui lòng đi tới
          <b><router-link :to="{ path: '/setting/config' }">Cấu hình bán hàng</router-link></b>
        </b-alert>
      </div>
    </div>

    <BottomPrice></BottomPrice>
    <el-form label-width="180px" class="w-100 mt-3">
      <el-form-item label="Tổng phải hoàn">
        <b>{{ formatMoneyNotUnit(getReturnMoney) }} đ</b>
      </el-form-item>
      <el-form-item v-if="refundPolicy" label="Thêm số tiền hoàn">
        <div class="d-flex">
          <el-select v-model="payMethod" style="width: 260px">
            <el-option v-for="item in payMethodList" :key="item.id" :label="item.text" :value="item.value"> </el-option>
          </el-select>
          <InputMoneyVmodel
            :max="returnAmount - getPricePayed"
            style="width: 260px"
            v-model="returnMoney"
            class="form-control ml-4"
          ></InputMoneyVmodel>
          <el-input class="ml-4" style="width: 260px" v-model="referenceCode" placeholder="Nhập mã tham chiếu" />
          <el-button class="ml-4" @click="addOutComeAmount" :disabled="getPricePayed == returnAmount || returnMoney == 0">Thêm</el-button>
        </div>
      </el-form-item>
    </el-form>
    <b-table v-if="refundPolicy" tbody-tr-class="repay-table" :items="rePay" :fields="fieldsRePay" :key="updateUI" show-empty>
      <template #empty>
        <EmptyTable content="Đơn trả chưa có thao tác hoàn tiền" noImage></EmptyTable>
      </template>
      <template #cell(requestAt)="data">
        {{ data.item.params.requestAt | formatDateTime }}
      </template>
      <template #cell(employeeName)="data">
        {{ data.item.params.employeeName }}
      </template>
      <template #cell(payMethod)="data">
        {{ allPayment[data.item.params.payMethod].name || data.item.params.payMethod }}
      </template>
      <template #cell(amount)="data">
        {{ formatMoneyNotUnit(data.item.params.amount) }}
      </template>
      <template #cell(gatewayTransactionId)="data">
        {{ data.item.params.gatewayTransactionId }}
      </template>
      <template #cell(edit)="data">
        <span @click="deleteItem(data.index)"><img class="delete-icon" src="@/assets/images/delete-vector.png"/></span>
      </template>
    </b-table>

    <div class="mt-3 w-100">
      <PayDetail>
        <template #title>Tổng tiền hàng trả</template>
        <template #price>{{ formatMoneyNotUnit(getReturnPrice) }} đ</template>
      </PayDetail>
      <PayDetail>
        <template #title>Tổng tiền hàng đổi</template>
        <template #price>{{ formatMoneyNotUnit(getExchangePrice) }} đ</template>
      </PayDetail>
      <div class="bottom-border w-50 ml-auto"></div>
      <PayDetail>
        <template #title>Tổng phải hoàn</template>
        <template #price
          ><b>{{ formatMoneyNotUnit(getReturnMoney) }} đ</b></template
        >
      </PayDetail>
      <PayDetail>
        <template #title>Đã thanh toán</template>
        <template #price>{{ formatMoneyNotUnit(getPricePayed) }} đ</template>
      </PayDetail>
      <div class="bottom-border w-50 ml-auto"></div>
      <PayDetail>
        <template #title>Còn lại</template>
        <template #price
          ><b>{{ formatMoneyNotUnit(getReturnMoneyAfterPay()) }} đ</b></template
        >
      </PayDetail>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BottomPrice from "./bottomPrice.vue";
import InputMoneyVmodel from "./inputMoneyVmodel.vue";
import PayDetail from "./payDetail.vue";
import { mapGetters } from "vuex";
import { allPayment } from "@/utils/mapping";

export default {
  components: { PayDetail, BottomPrice, InputMoneyVmodel },
  // props: ["dataItem","rePay"],
  props: {
    dataItem: {
      type: Object,
    },
    rePay: {
      type: Array,
    },
    refundPolicy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      allPayment: allPayment,
      test: "",
      updateUI: 1,
      payMethod: "CASH_NEXT_SHOP",
      payMethodList: [
        {
          id: 1,
          text: "Tiền mặt",
          value: "CASH_NEXT_SHOP",
        },
        {
          id: 2,
          text: "Chuyển khoản",
          value: "BANK_TRANSFER_NEXT_SHOP",
        },
      ],

      // rePay: [],
      fieldsRePay: [
        {
          key: "requestAt",
          label: "Thời gian",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "employeeName",
          label: "Người thực hiện",
          thStyle: {
            width: "20%",
            "min-width": "120px",
            "word-break": "break-word",
          },
        },
        {
          key: "payMethod",
          label: "Phương thức",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "amount",
          label: "Số tiền hoàn",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "gatewayTransactionId",
          label: "Mã tham chiếu",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "edit",
          label: "",
          thStyle: { width: "5%", "min-width": "50px" },
        },
      ],

      returnMoney: 0,
      referenceCode: ""
    };
  },
  // created() {
  //   this.returnMoney = this.returnAmount - this.getPricePayed;
  // },
  methods: {
    addOutComeAmount() {
      let item = {
        params: {
          payMethod: this.payMethod,
          amount: this.returnMoney,
          employeeName: this.dataItem.partyA.displayName,
          requestAt: moment(),
          gatewayTransactionId: this.referenceCode,
        },
      };
      // this.rePay.push(item);
      this.$emit("addRepayItem", item)
      this.returnMoney = 0;
      this.referenceCode = ""
    },

    deleteItem(index) {
      // this.rePay.splice(index, 1);
      this.$emit("deleteRepayItem", index)
      // this.outComeAmount = this.getPriceWillPay;
    },

    getPayMethod(method) {
      if (method == "BANK_TRANSFER") {
        return "Chuyển Khoản";
      } else if (method == "CASH") {
        return "Tiền mặt";
      } else {
        return "";
      }
    },
    getReturnMoneyAfterPay() {
      return this.refundPolicy ? this.returnAmount - this.getPricePayed : 0;
    },
  },
  computed: {
    ...mapGetters("ordersReturn", ["getReturnPrice", "getExchangePrice"]),
    returnAmount() {
      return this.getReturnPrice - this.getExchangePrice;
    },
    getPricePayed() {
      let total = 0;
      this.rePay.forEach((e) => {
        total += e.params.amount;
      });
      return total;
    },
    getPriceWillPay() {
      return this.returnAmount - this.getPricePayed;
    },
    getReturnMoney() {
      return this.refundPolicy ? this.returnAmount : 0
    },
  },
  watch: {
    getPricePayed: {
      handler() {
        // console.log( this.returnAmount , this.getPricePayed)
        this.returnMoney = this.getReturnMoneyAfterPay()
      },
      immediate: true,
    },
    getPriceWillPay() {
      this.returnMoney = this.getReturnMoneyAfterPay()
    }
  },
};
</script>

<style lang="scss" scoped></style>
